import React from 'react';

import imgSrc from './eng-flag.jpg';

const EngFlagIcon: React.FC = () => {
  return <img src={imgSrc} width="24" height="16" alt="eng" />;
};

export default EngFlagIcon;
